import http from '@/http';
import router from '@/router';

const types = {
    AUTH_SET_TOKEN: 'AUTH_SET_TOKEN',
    AUTH_SET_USER: 'AUTH_SET_USER',
    AUTH_REMOVE_TOKEN: 'AUTH_REMOVE_TOKEN',
    AUTH_SET_RESPONSE: 'AUTH_SET_RESPONSE',
    AUTH_SET_URL: 'AUTH_SET_URL',
};

export const state = {
    response: {},
    token: null,
    user: null,
    url: `${process.env.VUE_APP_BASE_URL}/api`,
};

export const getters = {
    isAuthenticated: ({ token }) => token !== null,
};

export const mutations = {
    [types.AUTH_SET_TOKEN](state, token) {
        state.token = token;
    },
    [types.AUTH_SET_URL](state, url) {
        state.url = url;
    },
    [types.AUTH_REMOVE_TOKEN](state) {
        state.token = null;
        state.user = null;
    },
    [types.AUTH_SET_USER](state, user) {
        state.user = user;
    },
    [types.AUTH_SET_RESPONSE](state, response) {
        state.response = response;
    },
};

export const actions = {
    authenticate({ state, commit }, fields) {
        return http.post('token', fields, { baseURL: state.url })
            .then((response) => {
                const { access_token } = response;

                commit(types.AUTH_SET_TOKEN, access_token);
                
                commit(types.AUTH_SET_RESPONSE, response);

                return access_token;
            })
            .catch(() => {
                this._vm.$toasted.show('Wrong username/password', { duration: 5000 });
            });
    },
    removeToken({ commit }) {
        commit(types.AUTH_REMOVE_TOKEN);

        if (router.currentRoute.name !== 'choose_measure') {
            router.push({ name: 'choose_measure' });
        }

        window.location.reload();
    },
};